import { captureException } from './errorTracking'

const isDev = import.meta.env.DEV

export const logger = {
  debug: (msg: string, ...args: unknown[]) => {
    if (isDev) console.debug(msg, ...args)
  },
  info: (msg: string, ...args: unknown[]) => {
    if (isDev) console.info(msg, ...args)
  },
  warn: (msg: string, ...args: unknown[]) => {
    console.warn(msg, ...args)
  },
  error: (msg: string, err?: unknown) => {
    console.error(msg, ...(err !== undefined ? [err] : []))
    captureException(err ?? new Error(msg), { message: msg })
  },
}
